import { mapInit } from "./contact/map"
export const contactInit = () => {
  mapInit()
}
